import React from "react";
import newImg from "../../assets/images/common/new_img.png";
import playButton from "../../assets/images/playButtonImg.png";
import { handleImageErrorCallBack } from "../../recommendation_industry_view/components/ErrorImage_PlaceHolder";

interface OverlayComponentProps {
  videoUrl: string;
  isSelected: boolean;
  isNew: boolean;
  width: string;
  height: string;
  playBtnWidth: string;
  playBtnHeight: string;
  videoTitle: string;
  onClick?: () => void;
  videoorcontenttext: string;
}

const OverlayComponent: React.FC<OverlayComponentProps> = ({
  videoUrl,
  isSelected,
  isNew,
  width,
  height,
  playBtnWidth,
  playBtnHeight,
  videoTitle,
  onClick,
  videoorcontenttext,
}) => {
  return (
    <div style={{ position: "relative", width, height }} onClick={onClick}>
      {/* Video Thumbnail */}
      <img
        src={videoUrl}
        alt={videoTitle}
        style={{
          width,
          height,
          cursor: onClick ? "pointer" : "default",
          ...(isSelected && {
            filter: "brightness(0.7)",
            color: "#044472cc",
          }),
        }}
        onError={(e) => handleImageErrorCallBack(e, width, height, onClick)}
      />

      {/* Play Button (conditionally rendered if not selected) */}
      {!isSelected && (
        <img
          src={playButton}
          alt="Play Button"
          style={{
            position: "absolute",
            cursor: "pointer",
            top: "50%",
            left: "50%",
            width: playBtnWidth,
            height: playBtnHeight,
            transform: "translate(-50%, -50%)",
          }}
        />
      )}

      {/* "Currently Playing" text (conditionally rendered if selected) */}
      {isSelected && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "25%",
            // transform: "translate(-50%, -50%)",
            color: "white",
            fontSize: "12px",
            fontFamily: "Mazzard",
            width: "100%",
          }}
        >
          {videoorcontenttext}
        </div>
      )}

      {/* "New" Flag */}
      {isNew && (
        <img
          src={newImg}
          alt="New"
          style={{
            position: "absolute",
            top: "8px",
            left: "8px",
            width: "30px",
            height: "20px",
          }}
        />
      )}
    </div>
  );
};

export default OverlayComponent;
